// The unfinished listing of the seller's wizard lives in this browser only. It holds what the person typed, so it is
// cleared when anybody signs out (on a shared computer the next visitor was offered the previous person's draft), and
// the contact details never go into it.
export const WIZARD_DRAFT_KEY = 'property_draft_v2';

export function clearWizardDraft(): void {
  try {
    localStorage.removeItem(WIZARD_DRAFT_KEY);
  } catch {}
  try {
    sessionStorage.removeItem('property_draft_tab');
    sessionStorage.removeItem('wizard_lang_switch');
  } catch {}
}

// A language switch reloads the page; the wizard hands what was typed to the next page through the tab's own storage
// (it goes away with the tab, and signing out clears it too).
export const WIZARD_TAB_KEY = 'property_draft_tab';
const SWITCH_FLAG = 'wizard_lang_switch';

export function markLanguageSwitch(): void {
  try {
    sessionStorage.setItem(SWITCH_FLAG, String(Date.now()));
  } catch {}
}

/** The form as it stood when the language was switched, or null (a fresh visit, or a switch long ago). */
export function takeLanguageSwitchDraft<T>(): T | null {
  try {
    const at = Number(sessionStorage.getItem(SWITCH_FLAG) || 0);
    sessionStorage.removeItem(SWITCH_FLAG);
    if (!at || Date.now() - at > 15_000) return null;
    const raw = sessionStorage.getItem(WIZARD_TAB_KEY);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
